import { useState, useEffect } from "react";

// useState that mirrors its value to localStorage so it survives reloads.
// It also syncs live across every component using the same key (via a custom
// event), so e.g. a toggle rendered in two places stays in lock-step.
export default function usePersistentState(key, initial) {
  const [value, setValue] = useState(() => {
    try {
      const raw = localStorage.getItem(key);
      return raw !== null ? JSON.parse(raw) : initial;
    } catch {
      return initial;
    }
  });
  useEffect(() => {
    try {
      const next = JSON.stringify(value);
      if (localStorage.getItem(key) !== next) {
        localStorage.setItem(key, next);
        window.dispatchEvent(new CustomEvent("rp-persist", { detail: { key } }));
      }
    } catch { /* ignore */ }
  }, [key, value]);
  useEffect(() => {
    const onEvt = (e) => {
      if (e?.detail?.key !== key) return;
      try {
        const raw = localStorage.getItem(key);
        const parsed = raw !== null ? JSON.parse(raw) : initial;
        setValue((prev) => (JSON.stringify(prev) === JSON.stringify(parsed) ? prev : parsed));
      } catch { /* ignore */ }
    };
    window.addEventListener("rp-persist", onEvt);
    return () => window.removeEventListener("rp-persist", onEvt);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return [value, setValue];
}
